import {
  Body3,
  Box,
  Color,
  Display,
  JustifyContent,
  Strong,
  TextAlign,
} from '@gousto-internal/citrus-react';

type Props = {
  isBestValue: boolean;
  recipesRemainingForBestValue: number;
};

function getNudgeCopy({ isBestValue, recipesRemainingForBestValue }: Props): string {
  if (isBestValue) {
    return "You've got the best price per portion!";
  }
  const noun = recipesRemainingForBestValue === 1 ? 'recipe' : 'recipes';
  return `Select ${recipesRemainingForBestValue} more ${noun} for the best price`;
}

export function NudgeBanner({ isBestValue, recipesRemainingForBestValue }: Props) {
  return (
    <Box
      bg={isBestValue ? Color.Success_900 : Color.ColdGrey_800}
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      paddingV={2}
      paddingH={3}
    >
      <Body3 color={Color.White} textAlign={TextAlign.Center}>
        <Strong>{getNudgeCopy({ isBestValue, recipesRemainingForBestValue })}</Strong>
      </Body3>
    </Box>
  );
}
